import React, {useEffect, useState} from 'react';
import {Container, Grid, ButtonBase, } from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {PersonAdd, HighlightOff } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple, showMessagePersonalizedToast} from 'services/SweetAlert'
import DialogLoadingMessage from 'components/BackDrop';
import Title from 'components/TitleWithIcon';
import {functions} from 'constants/index';
import ComponentePasarAFallecidosCiudadano from 'components/CustomDialog';
function FormularioCreacionUsuario(props) {
    const classes = useStyles(),        
        [loading, setLoading] = React.useState(false);

    // const AgregarCaptacionDeFallecido= async ()=>{
    //     var saveData = {}
    //     var datosDelFormulario = elements        
    //     Object.keys(datosDelFormulario).forEach((element, key, _array) =>{
    //         if(datosDelFormulario[element].idelement === 'coddepto' || datosDelFormulario[element].idelement === 'codmunic'){
    //             saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value.id;
    //         }
    //         else if(datosDelFormulario[element].elementType === 'date'){
    //             saveData[datosDelFormulario[element].idelement] = new Date(datosDelFormulario[element].value);
    //             // saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value;
    //         }
    //         else if(datosDelFormulario[element].idelement !== 'titleDatosDeLaMadre' && datosDelFormulario[element].idelement !== 'titleDatosDelPadre' &&
    //             datosDelFormulario[element].idelement !== 'titleDatosFallecidos' && datosDelFormulario[element].idelement !== 'titleFolio' &&
    //             datosDelFormulario[element].idelement !== 'titleRestoDeDatos' && datosDelFormulario[element].idelement !== 'firmaElectronica'
    //         ) {
    //             saveData[datosDelFormulario[element].idelement] = typeof datosDelFormulario[element].value === 'string' ?  datosDelFormulario[element].value.toUpperCase(): datosDelFormulario[element].value;
    //         }
    //     }) 
    //     setLoading(true)
    //     try{
    //         const response =  await ApiServices.captacionFallecidos.captacionFallecido(saveData)
    //         if(response.error!==null){
    //             showMessagePersonalizedToast('warning', '¡Oops! ' +response.error.message)
    //         }else{
    //             showMessageSuccessSimple('¡BIEN!', response.data)
    //             Cancelar();
    //         }   
    //     }catch(exception){
    //         if (exception.status===404) {
    //             showMessagePersonalizedToast('error', '¡Oops! ' +"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
    //         }
    //         else {
    //             showMessagePersonalizedToast('error', '¡Oops! ' +"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
    //         }
    //     }                 
    //     setLoading(false)
    // };
    const CreateUser = () => {

    }
    const [elements,setElements] = useState({
        nroEmpleado: {
            idelement: "nroEmpleado",  value:'', label: "No. Empleado *", pattern:"^[\\w1-9_Ññ-]{1,11}$", 
            validators: ['required'], errorMessages:['Ingrese No. Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
        },
        nombre: {
            idelement: "nombre",  value:'', label: "Ingrese nombre del empleado *", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){1,25}$", 
            validators: ['required'], errorMessages:['Ingrese nombre del empleado, sin espacios al inicio y final'], isError:false, elementType:'input',
        },
        email: {
            idelement: "email", value:'', label: "Ingrese corre electrónico", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,3}$", validators: ['required'], 
            errorMessages:['Ingrese un correo válido'], isError:false, elementType:'input' 
        },
        password: { 
            idelement: "password",  value:'', label: "Clave", pattern:"^[\\w_\\sÑñáéíóúÁÉÍÓÚ().$@#!¡:;{}+=^~|%*¿?&/-]{6,20}$", validators: ['required'], 
            errorMessages:['Ingrese contraseña válida'], isError:false, elementType:'password' 
        },
        confirmPassword: { 
            idelement: "confirmPassword",  value:'', label: "Confirmar Clave", pattern:"^[\\w_\\sÑñáéíóúÁÉÍÓÚ().$@#!¡:;{}+=^~|%*¿?&/-]{6,20}$", validators: ['required'], 
            errorMessages:['Ingrese contraseña válida'], isError:false, elementType:'password' 
        },
        // password: { idelement: "password",  value:'', label: 'Ingrese contraseña', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },        
    });    
    
    const [buttonList,setButtonList]= React.useState({
        "createUser":{"label":"Crear Usuario","icon": <PersonAdd />,"callback":CreateUser,"loading":loading, disabled:loading},   
        "cancel":{"label":"Cerrar","icon": <HighlightOff />,"callback":props.closeModalFormCreateUser,"loading":loading, disabled:loading, isCancel:true, IsButtonCancelar:true},
    });

    return (
        <div id="scroller" className={classes.root}>
            {/* <DialogLoadingMessage open={this.state.loadingCancelUser} title={'Cancelando Usuario ...'}/> */}
            <ComponentePasarAFallecidosCiudadano 
                open={props.openFormCreateUser}
                fullScreen={true}
                closeModal={props.closeModalFormCreateUser}
                actualizarTabla={props.updateTable}
                iconToolbar={<PersonAdd />}
                titleToolbar={'Proceso de Creación de usuario'}
            >            
                <br/>
                <Container className={classes.colorComponente}>
                    <Grid container >
                        <Title title="Formulario de creación de usuario" icon={"/assets/PerfilUsuario.png"}/>
                        <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>                
                            <Form 
                                elements= {elements}  
                                buttonList={buttonList} 
                            />
                        </Grid>
                    </Grid>
                    <div className={classes.lineaDegradadaBottom}></div>
                </Container>
            </ComponentePasarAFallecidosCiudadano>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(FormularioCreacionUsuario);